<template>
  <section>
    <b-form-row>
      <b-col>
        <van-divider
          :style="{ color: 'blue', borderColor: 'blue', 'font-size': '1.5em' }"
        >{{ $t('dharma-application-form.applicant.delivery.title') }}</van-divider>
      </b-col>
    </b-form-row>
    <b-form-group :label="$t('dharma-application-form.applicant.delivery.label.area')" label-size="lg" label-for="area">
      <b-form-select id="area" v-model="delivery.area">
        <template #first>
          <b-form-select-option value="" disabled>{{ $t('dharma-application-form.applicant.delivery.area-selector.hint') }}</b-form-select-option>
        </template>
        <b-form-select-option
          :value="area.english_name"
          v-for="(area, index) in areas"
        >{{ $i18n.locale === 'tw' ? area.chinese_name : area.english_name }}</b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.customs-duty-option')"
      label-size="lg"
      label-for="customs_duty_option"
      v-if="delivery.area && delivery.area !== 'Taiwan'"
    >
      <b-form-text
        tag="p"
        text-variant="warning"
        class="font-weight-bold"
        v-html="$t('dharma-application-form.applicant.delivery.instruction-text.customs-duty-option')"
        v-if="is_bulk_application"
      ></b-form-text>
      <b-form-select id="customs_duty_option" v-model="delivery.customs_duty_option">
        <template #first>
          <b-form-select-option value="" disabled>{{ $t('dharma-application-form.applicant.delivery.customs-duty-option-selector.hint') }}</b-form-select-option>
        </template>
        <b-form-select-option
          :value="customs_duty_option.key"
          v-for="(customs_duty_option, index) in customs_duty_options"
        >{{ customs_duty_option[`label-${$i18n.locale}`] }}</b-form-select-option>
      </b-form-select>
      <b-form-text
        tag="p"
        text-variant="danger"
        class="font-weight-bold"
        v-html="$t('dharma-application-form.applicant.delivery.disclaimer-text.customs-duty-option.unable-to-pay')"
        v-if="delivery.customs_duty_option === 'unable-to-pay' && !is_bulk_application"
      ></b-form-text>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.shipping-cost-option')"
      label-size="lg"
      label-for="shipping_cost_option"
      v-if="delivery.area === 'China Mainland'"
    >
      <b-form-select id="shipping_cost_option" v-model="delivery.shipping_cost_option">
        <template #first>
          <b-form-select-option value="" disabled>{{ $t('dharma-application-form.applicant.delivery.shipping-cost-option-selector.hint') }}</b-form-select-option>
        </template>
        <b-form-select-option
          :value="shipping_cost_option.key"
          v-for="(shipping_cost_option, index) in shipping_cost_options"
        >{{ shipping_cost_option[`label-${$i18n.locale}`] }}</b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.shipping-cost-option-description')"
      label-size="lg"
      label-for="shipping_cost_option_description"
      v-if="delivery.area === 'China Mainland' && delivery.shipping_cost_option === 'unable-to-cover-shipping-cost'"
    >
      <b-form-textarea
        trim
        id="shipping_cost_option_description"
        v-model="delivery.shipping_cost_option_description"
      ></b-form-textarea>
      <b-form-text tag="p" text-variant="primary" class="font-weight-bold">
        {{ $t('dharma-application-form.applicant.delivery.instruction-text.shipping-cost-option-description') }}
      </b-form-text>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.nearest-available-port')"
      label-size="lg"
      label-for="nearest_available_port"
      v-if="is_bulk_application && delivery.area && delivery.area !== 'Taiwan'"
    >
      <b-form-input id="nearest_available_port" v-model="delivery.nearest_available_port" trim></b-form-input>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.can-clear-customs')"
      label-size="lg"
      label-for="can_clear_customs"
      v-if="is_bulk_application && delivery.area && delivery.area !== 'Taiwan'"
    >
      <b-form-select id="can_clear_customs" v-model="delivery.can_clear_customs">
        <b-form-select-option value="Y">{{ $t('dharma-application-form.applicant.delivery.option.yes') }}</b-form-select-option>
        <b-form-select-option value="N">{{ $t('dharma-application-form.applicant.delivery.option.no') }}</b-form-select-option>
      </b-form-select>
      <b-form-text
        tag="p"
        text-variant="warning"
        class="font-weight-bold"
        v-html="$t('dharma-application-form.applicant.delivery.disclaimer-text.can_clear_customs.no')"
        v-if="delivery.can_clear_customs === 'N'"
      ></b-form-text>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.object')"
      label-size="lg"
      label-for="object"
      v-if="delivery.area === 'Taiwan'"
    >
      <b-form-select id="object" v-model="delivery.object">
        <b-form-select-option value="applicant">{{ $t('dharma-application-form.applicant.delivery.object-selector.option.applicant') }}</b-form-select-option>
        <!-- <b-form-select-option value="cvs">{{ $t('dharma-application-form.applicant.delivery.object-selector.option.cvs') }}</b-form-select-option> -->
      </b-form-select>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.postal-code')"
      label-size="lg"
      label-for="postal_code"
      v-if="delivery.area && delivery.object === 'applicant' && $i18n.locale === 'tw'"
    >
      <b-form-input id="postal_code" autocomplete="postal-code" v-model="delivery.postal_code" trim></b-form-input>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.address')"
      label-size="lg"
      v-if="delivery.area && delivery.object === 'applicant'"
    >
      <template v-if="$i18n.locale === 'tw'">
        <b-form-group label-for="city">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.city') }}</h5></slot>
          <b-form-input
            trim
            id="city"
            :autocomplete="delivery.area && delivery.area === 'Taiwan' ? 'address-level2' : 'address-level1'"
            v-model="delivery.city"
          ></b-form-input>
          <b-form-text tag="p" text-variant="warning" class="font-weight-bold" v-if="delivery_to_taipei_area">
            {{ $t('dharma-application-form.applicant.delivery.reminder-text.city.can-apply-at-the-counter') }}
          </b-form-text>
        </b-form-group>
        <b-form-group label-for="district">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.district') }}</h5></slot>
          <b-form-input
            trim
            id="district"
            :autocomplete="delivery.area && delivery.area === 'Taiwan' ? 'address-level3' : 'address-level2'"
            v-model="delivery.district"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-for="street_address">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.street-address') }}</h5></slot>
          <b-form-input
            trim
            id="street_address"
            autocomplete="street-address"
            v-model="delivery.street_address"
          ></b-form-input>
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group label-for="street_address">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.street-address') }}</h5></slot>
          <b-form-input
            trim
            id="street_address"
            autocomplete="street-address"
            v-model="delivery.street_address"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-for="district">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.district') }}</h5></slot>
          <b-form-input
            trim
            id="district"
            :autocomplete="delivery.area && delivery.area === 'Taiwan' ? 'address-level3' : 'address-level2'"
            v-model="delivery.district"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-for="city">
          <slot name="label"><h5>{{ $t('dharma-application-form.applicant.delivery.label.city') }}</h5></slot>
          <b-form-input
            trim
            id="city"
            :autocomplete="delivery.area && delivery.area === 'Taiwan' ? 'address-level2' : 'address-level1'"
            v-model="delivery.city"
          ></b-form-input>
          <b-form-text tag="p" text-variant="warning" class="font-weight-bold" v-if="delivery_to_taipei_area">
            {{ $t('dharma-application-form.applicant.delivery.reminder-text.city.can-apply-at-the-counter') }}
          </b-form-text>
        </b-form-group>
      </template>
      <b-form-row v-if="delivery.area">
        <b-col>
          <p class="text-primary font-weight-bold">
            {{ $t('dharma-application-form.applicant.delivery.help-text.address') }}
          </p>
        </b-col>
      </b-form-row>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.postal-code')"
      label-size="lg"
      label-for="postal_code"
      v-if="delivery.area && delivery.object === 'applicant' && $i18n.locale !== 'tw'"
    >
      <b-form-input id="postal_code" v-model="delivery.postal_code" trim></b-form-input>
    </b-form-group>
    <b-form-group
      :label="$t('dharma-application-form.applicant.delivery.label.cvs-code')"
      label-size="lg"
      label-for="cvs_code"
      v-if="delivery.area === 'Taiwan' && delivery.object === 'cvs'"
    >
      <b-form-input id="cvs_code" v-model="delivery.info.cvs_code" trim></b-form-input>
      <b-button
        block
        href="http://map.ezship.com.tw/"
        target="_blank"
        variant="outline-info"
      >{{ $t('dharma-application-form.applicant.delivery.button.cvs-code-inquiry.label') }}</b-button>
      <b-button
        block
        href="http://www-old.budaedu.org/books/apply/note.pdf"
        target="_blank"
        variant="bg-transparent"
      >{{ $t('dharma-application-form.applicant.delivery.button.cvs-code-pickup-service-instructions.label') }}</b-button>
    </b-form-group>
    <b-form-row v-if="Object.keys(validation_results.delivery).length > 0">
      <b-col class="text-danger">
        <p
          class="font-weight-bold"
          v-for="field in validation_results.delivery.fieldErrors"
        >{{ field.message }}</p>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <van-divider
          :style="{ color: 'green', borderColor: 'green', 'font-size': '1.5em' }"
        >{{ $t('dharma-application-form.applicant.contact.title') }}</van-divider>
      </b-col>
    </b-form-row>
    <b-form-group
      label-size="lg"
      label-for="name"
      :label="$t('dharma-application-form.applicant.contact.individual.label.name')"
    >
      <b-form-input id="name" autocomplete="name" v-model="applicant.name" trim class="input"></b-form-input>
      <b-form-text tag="p" text-variant="primary" class="font-weight-bold">
        {{ $t('dharma-application-form.applicant.contact.help-text.name.fill-in-chinese-or-english') }}
      </b-form-text>
      <b-form-text tag="p" text-variant="warning" class="font-weight-bold" v-if="delivery.area === 'China Mainland'">
        {{ $t('dharma-application-form.applicant.contact.help-text.name.fill-in-the-real-name') }}
      </b-form-text>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="group_name"
      :label="$t('dharma-application-form.applicant.contact.individual.label.group-name')"
      v-if="is_bulk_application"
    >
      <b-form-input id="group_name" autocomplete="organization" v-model="applicant.group_name" trim></b-form-input>
      <b-form-text tag="p" text-variant="primary" class="font-weight-bold">
        {{ $t('dharma-application-form.applicant.contact.help-text.group-name.fill-in-chinese-or-english') }}
      </b-form-text>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="email"
      :label="$t('dharma-application-form.applicant.contact.individual.label.email')"
    >
      <b-form-input id="email" autocomplete="email" v-model="applicant.email" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="phone"
      :label="$t('dharma-application-form.applicant.contact.individual.label.phone')"
    >
      <b-form-input id="phone" autocomplete="tel" v-model="applicant.phone" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="mobile_phone"
      :label="$t('dharma-application-form.applicant.contact.individual.label.mobile-phone')"
    >
      <b-form-input id="mobile_phone" autocomplete="tel" v-model="applicant.mobile_phone" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="fax"
      :label="$t('dharma-application-form.applicant.contact.individual.label.fax')"
      v-if="is_bulk_application"
    >
      <b-form-input id="fax" v-model="applicant.fax" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="official_email"
      :label="$t('dharma-application-form.applicant.contact.individual.label.official-email')"
      v-if="is_bulk_application && delivery.area === 'India'"
    >
      <b-form-input id="official_email" v-model="applicant.official_email" trim></b-form-input>
    </b-form-group>
    <b-form-row v-if="(is_bulk_application && ['Brazil', 'India', 'Bhutan', 'Nepal', 'Indonesia'].includes(delivery.area)) || (!is_bulk_application && delivery.area === 'Brazil')">
      <b-col>
        <van-divider
          :style="{ color: '#ed6a0c', borderColor: '#ed6a0c', 'font-size': '1.5em' }"
        >{{ $t('dharma-application-form.applicant.tax.title') }}</van-divider>
      </b-col>
    </b-form-row>
    <b-form-group
      label-size="lg"
      label-for="tin"
      :label="$t('dharma-application-form.applicant.tax.label.tin')"
      v-if="(is_bulk_application && ['Brazil', 'India', 'Bhutan', 'Nepal', 'Indonesia'].includes(delivery.area)) || (!is_bulk_application && delivery.area === 'Brazil')"
    >
      <b-form-input id="tin" v-model="applicant.tin" trim></b-form-input>
      <b-form-text
        tag="p"
        text-variant="danger"
        class="font-weight-bold"
        v-html="$t(`dharma-application-form.applicant.contact.help-text.tin.need-to-fill-in-${is_bulk_application ? 'for-large-quantity-applications' : 'for-small-quantity-applications'}`)"
      ></b-form-text>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="iec"
      :label="$t('dharma-application-form.applicant.tax.label.iec')"
      v-if="is_bulk_application && delivery.area === 'India'"
    >
      <b-form-input id="iec" v-model="applicant.iec" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="pan"
      :label="$t('dharma-application-form.applicant.tax.label.pan')"
      v-if="is_bulk_application && delivery.area === 'India'"
    >
      <b-form-input id="pan" v-model="applicant.pan" trim></b-form-input>
    </b-form-group>
    <b-form-group
      label-size="lg"
      label-for="gstin"
      :label="$t('dharma-application-form.applicant.tax.label.gstin')"
      v-if="is_bulk_application && delivery.area === 'India'"
    >
      <b-form-input id="gstin" v-model="applicant.gstin" trim></b-form-input>
    </b-form-group>
    <b-form-row v-if="delivery.area == 'China Mainland'">
      <b-col class="text-primary">
        <p class="font-weight-bold">{{ $t('dharma-application-form.applicant.contact.help-text.strictly-prohibited-for-sale') }}</p>
      </b-col>
    </b-form-row>
    <b-form-row v-if="Object.keys(validation_results.applicant).length > 0">
      <b-col class="text-danger">
        <p
          class="font-weight-bold"
          v-for="field in validation_results.applicant.fieldErrors"
        >{{ field.message }}</p>
      </b-col>
    </b-form-row>
  </section>
</template>
<script>
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

import { ButtonPlugin } from 'bootstrap-vue'
import { Divider } from 'vant'
import { FormGroupPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { FormTextareaPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { Validators, createFormValidation } from '@lemoncode/fonk'
import { requiredByField } from '@lemoncode/fonk-required-by-field-validator'

import i18n from '@/plugins/i18n.js'

import ContainsNoChineseCharactersValidator from '@/services/fonk-validation-service/contains-no-chinese-characters-validator'
import DharmaDeliveryAreaApiService from '@/services/budaedu-api-services/dharma-delivery-area-api-service.js'

Vue.use(ButtonPlugin)
Vue.use(Divider)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(LayoutPlugin)
Vue.use(VueLocalStorage)

Vue.use(DharmaDeliveryAreaApiService)

export default {
  i18n,
  name: 'individual-form',
  props: {
    form_data: {
      type: Object,
      default: () => ({})
    },
    is_bulk_application: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      areas: [],
      customs_duty_options: [],
      shipping_cost_options: [],
      delivery: {
        area: '',
        object: 'applicant',
        postal_code: '',
        city: '',
        district: '',
        street_address: '',
        customs_duty_option: '',
        shipping_cost_option: '',
        shipping_cost_option_description: '',
        nearest_available_port: '',
        can_clear_customs: '',
        info: {
          cvs_code: ''
        }
      },
      applicant: {
        name: '',
        group_name: '',
        email: '',
        phone: '',
        mobile_phone: '',
        fax: '',
        official_email: '',
        tin: '',
        pan: '',
        gstin: '',
        iec: '',
        type: 'individual'
      },
      validation_results: {
        applicant: {},
        delivery: {}
      }
    }
  },
  watch: {
    form_data: {
      handler(new_value) {
        if (new_value) {
          if (new_value.delivery) {
            this.delivery = { ...this.delivery, ...new_value.delivery }
          }
          if (new_value.applicant) {
            this.applicant = { ...this.applicant, ...new_value.applicant }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    delivery_to_taipei_area() {
      if (!this.delivery.city) {
        return false
      }
      return /(臺北|台北|Taipei)/i.test(this.delivery.city)
    },
    validation_schema() {
      return {
        field: {
          area: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.delivery.error-message.area.required')
          }],
          postal_code: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.delivery.error-message.postal-code.required')
          }],
          city: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.city.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.city.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1
              }
            }
          ],
          district: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.district.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.district.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1
              }
            }
          ],
          street_address: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.street-address.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.delivery.error-message.street-address.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1
              }
            }
          ],
          customs_duty_option: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'area',
              condition: (value) => value && value !== 'Taiwan'
            },
            message: this.$t('dharma-application-form.applicant.delivery.error-message.customs-duty-option.required')
          }],
          shipping_cost_option: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'area',
              value: 'China Mainland'
            },
            message: this.$t('dharma-application-form.applicant.delivery.error-message.shipping-cost-option.required')
          }],
          shipping_cost_option_description: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'area',
              condition: (value, values) => 
                value === 'China Mainland' && values.shipping_cost_option === 'unable-to-cover-shipping-cost'
            },
            message: this.$t('dharma-application-form.applicant.delivery.error-message.shipping-cost-option-description.required')
          }],
          can_clear_customs: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'area',
              condition: (value) => value && value !== 'Taiwan' && this.is_bulk_application
            },
            message: this.$t('dharma-application-form.applicant.delivery.error-message.can-clear-customs.required')
          }],
          "info.cvs_code": [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.delivery.error-message.cvs-code.required')
          }],
          name: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.contact.individual.error-message.name.required')
            },
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.contact.individual.error-message.name.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1
              }
            }
          ],
          group_name: [
            {
              validator: ContainsNoChineseCharactersValidator,
              message: this.$t('dharma-application-form.applicant.contact.individual.error-message.group-name.some-areas-support-chinese-input'),
              customArgs: {
                condition: () => this.delivery.area && ['Taiwan', 'China Mainland', 'Hong Kong', 'Macao', 'Japan'].indexOf(this.delivery.area) === -1
              }
            }
          ],
          email: [
            {
              validator: Validators.required,
              message: this.$t('dharma-application-form.applicant.contact.individual.error-message.email.required')
            },
            {
              validator: Validators.email,
              message: this.$t('dharma-application-form.applicant.contact.individual.error-message.email.invalid')
            }
          ],
          phone: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.contact.individual.error-message.phone.required')
          }],
          mobile_phone: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.contact.individual.error-message.mobile-phone.required')
          }],
          official_email: [
            {
              validator: Validators.email,
              message: this.$t('dharma-application-form.applicant.contact.individual.error-message.official-email.invalid')
            }
          ],
          tin: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.tax.error-message.tin.required')
          }],
          iec: [{
            validator: Validators.required,
            message: this.$t('dharma-application-form.applicant.tax.error-message.iec.required')
          }],
          pan: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'gstin',
              condition: (value) => !value
            },
            message: this.$t('dharma-application-form.applicant.tax.error-message.pan.required')
          }],
          gstin: [{
            validator: requiredByField.validator,
            customArgs: {
              field: 'pan',
              condition: (value) => !value
            },
            message: this.$t('dharma-application-form.applicant.tax.error-message.gstin.required')
          }]
        }
      }
    }
  },
  methods: {
    async validateForm() {
      await this.validateDeliveryForm()
      await this.validateApplicantForm()
      return (
        this.validation_results.delivery.succeeded &&
        this.validation_results.applicant.succeeded
      )
    },
    async validateDeliveryForm() {
      let validation_schema = null
      if (this.delivery.area) {
        validation_schema = (this.delivery.object === 'cvs')
          ? this.getValidationSchemaByFieldName(['area', 'info.cvs_code'])
          : this.getValidationSchemaByFieldName([
              'area', 'postal_code', 'city', 'district', 'street_address',
              'customs_duty_option', 'shipping_cost_option', 'shipping_cost_option_description',
              'can_clear_customs'
            ])
      } else {
        validation_schema = this.getValidationSchemaByFieldName(['area'])
      }

      const validation = createFormValidation(validation_schema)
      await validation
        .validateForm(this.delivery)
        .then(form_validation_result => {
          this.validation_results.delivery = form_validation_result
        })
    },
    async validateApplicantForm() {
      let field_name = ['name', 'email', 'phone', 'mobile_phone']
      if (this.is_bulk_application) {
        field_name = field_name.concat(['group_name'])
        if (this.delivery.area === 'India') {
          field_name = field_name.concat(['official_email'])
        }
      } else {
        if (this.delivery.area === 'Brazil') {
          field_name = field_name.concat(['tin'])
        }
      }
      
      const validation_schema = this.getValidationSchemaByFieldName(field_name)
      const validation = createFormValidation(validation_schema)
      await validation
        .validateForm(this.applicant)
        .then(form_validation_result => {
          this.validation_results.applicant = form_validation_result
        })
    },
    getValidationSchemaByFieldName(field_name) {
      const field_validation_schema = field_name.reduce((field_validation_schema, key) => {
        if (this.validation_schema.field.hasOwnProperty(key)) {
          field_validation_schema[key] = this.validation_schema.field[key];
        }
        return field_validation_schema;
      }, {});

      return { field: field_validation_schema }
    },
    async setAreas() { 
      const items = await this.$dharmaDeliveryAreaApiService.query('filter[can_deliver]=Y&order=priority,asc|english_name,asc')
      this.areas = items.data
    },
    async setCustomsDutyOptions() {
      const item = await this.$constantApiService.getFromMemberSystem()
      this.customs_duty_options = item.data.customs_duty_options
    },
    async setShippingCostOptions() { 
      const item = await this.$constantApiService.getFromMemberSystem()
      this.shipping_cost_options = item.data.shipping_cost_options
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setAreas()
    await this.setShippingCostOptions()
    await this.setCustomsDutyOptions()
  },
  components: {
    // 
  }
}
</script>